
import Vue from "vue";
import { UblDossierConfig } from "../../../plugins/ubl/models/ubl-dossier-config";
import { ISelectItem } from "winfakt-vue-components";
import AppLedgerAccountAutocomplete from "@/components/common/LedgerAccountAutocomplete.vue";
import AppIncludePdfsInArchiveModeSelect from "@/components/settings-default/IncludePdfsInArchiveModeSelect.vue";
import AppPaymentMeansCodeSelect from "@/components/settings-default/PaymentMeansCodeSelect.vue";

export default Vue.extend({
	props: {
		config: {
			type: Object as () => UblDossierConfig,
			required: true,
		}
	},
	computed: {
		ublTypes():ISelectItem<string>[]{
			return [
				{
					text: this.$ct("ubl-type-invoice"),
					value: "invoice"
				},
				{
					text: this.$ct("ubl-type-e-fff"),
					value: "e-fff"
				},
				{
					text: this.$ct("ubl-type-peppol"),
					value: "peppol"
				}
			];
		}
	},
	methods: {
		save(){
			this.$emit("save-config");
		},
	},
	async created(){
	},
	components: {
		AppLedgerAccountAutocomplete,
		AppIncludePdfsInArchiveModeSelect,
		AppPaymentMeansCodeSelect
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
